OcList = {};
Nas = {};

OcList.refreshGrid = function(rootEl) {
    csd('OcList.refreshGrid');
    rootEl.kontoGrid.refresh(false);
};

//funkcija koja otvara modalni dijalog s proslijedjenim opcijama, template-om i callback metodom
OcList.pozoviModalni = function(rootEl, tpl, callback, modalOptions) {
	csd('OcList.pozoviModalni');
	var gridData = rootEl.kontoGrid.getSelectedData();
	
	var modalId = kontorouter.getModalIdFromLink(false);
	
	if (typeof tpl === 'function') {
		var template = tpl();
	} else {
		var template = kontorouter.getModulPath(tpl);
		var modalId = kontorouter.getModalIdFromLink(tpl);
	}
	
	var _modalOptions = {
		//width: '600px',
		id: modalId,
		template: template,
		data: {},
		templateLoaded: function () {
			modal.element.find("form").on("onUpis", function (event, data) {
				if (typeof callback === 'function')
					callback(rootEl);
				else if (callback !== false)
					OcList.refreshGrid(rootEl);
            });
		}
	};
	var options = $.extend({}, _modalOptions, modalOptions);
	var modal = konto.dialogs.modal(options);
	
};
	
OcList.getFilterData = function() { 
    csd('OcList.getFilterData');
    var data = {};
    
    $.each(OcList.filter, function(field, value) {
        data[field] = value.filterValue;
    });
    
    return JSON.stringify(data);
};


OcList.getCheckedData = function(sifarnik, key) {
	csd('OcList.getCheckedData');
	
	var key = key || 'OcList';
	var pkey = key.toUpperCase();
	
	var data = sifarnik.kontoGrid.getCheckedData();
	var list = {};
		list[key] = [];

	if (!empty(data) || data != null)
		$.each(data, function(k, val) {
			list[key].push(val[pkey]);
		});

	return list;
};

//za naslijedjivanje
Nas = OcList;

//funkcije za enkapsulaciju tagova (tr,td,th) - da ne pisem goli html kod
var encapsulate = function(el, data, options) { 
	if (!isset(el)) return;
		
	var opt = isset(options)? ' '+options : '';
	var data = isset(data)? data : '';
	
	return '<'+el+opt+'>' + data + '</'+el+'>'; 
};
var td = function(data, options) { return encapsulate('td', data, options); };
var tr = function(data, options) { return encapsulate('tr', data, options); };
var th = function(data, options) { return encapsulate('th', data, options); };
var div = function(data, options) { return encapsulate('div', data, options); };
	
$(document).ready(function() {

});

